// extracted by mini-css-extract-plugin
export default {"line_table_link":"styles_line_table_link__QY4TE","navigate_table":"styles_navigate_table__5Z3jW","search_block":"styles_search_block__diq1t"};